import React, { useEffect, useState } from "react";
import { Page, CardContainer, CustomTable, useStyles, Button } from "../../../../components";
import { useSelector } from "react-redux";
import { getDqrList } from "../../../../lib/ec2-dqr-api";
import { Plus, CircleFilled } from "../../../../components/Icons";
import DqrResyncModal from "./DqrResyncModal";
import DqrProvisionModal from "./DqrProvisionModal";
import { dqrHwCheckCon } from "../../../../lib/ec2-dqr-api";
import { sortObjArray } from "../../../../lib/utils";
import { ConnectSign } from "../../../../components/Icons";
// import { debug } from "../../../../settings";

const tableHeader = [
  { name: "uid", displayName: "UID" },
  { name: "tableNo", displayName: "Table No" },
  { name: "tableName", displayName: "Table Name" },
  { name: "ver", displayName: "Version" },
  { name: "active", displayName: "In Use" },
];

/** @TODO provision 후 dqr list update  */

export default function DqrSetting(props) {
  const { shopInfo } = useSelector(state => state.shop);
  const { itemOptions3 } = useSelector(state => state.items)

  const { gStyle, colors } = useStyles();

  const [dqrList, setDqrList] = useState([])
  const [selDqr, setSelDqr] = useState({})
  const [visible, setVisible] = useState(false)
  const [visibleProvision, setVisibleProvision] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  const [dqrHwCon, setDqrHwCon] = useState(false)
  const [dqrHwInfo, setDqrHwInfo] = useState({})

  useEffect(() => {
    listDqrs()
  }, [shopInfo])

  const listDqrs = async () => {
    try {
      const res = await getDqrList({ shopId: shopInfo.shopId })
      if (res.err) return null
      const newList = sortObjArray({ arr: res.result.Items, key: "created", type: "down" })
      setDqrList(newList)
    } catch (e) {
      alert(e.message)
    }
  }

  useEffect(() => {
    checkDqrConnection()
  }, [])

  // 
  // if dqrHw con then set dqrHwCon, 
  // if DQR provisioned then set dqrHwInfo 
  // 
  const checkDqrConnection = async () => {
    try {

      // 
      // response
      // 1. NOCONN Error
      // 2. Empty Object {}
      // 3. Provision Data {ver, shopId, ...}
      // 
      const res = await dqrHwCheckCon()
      if (res.err) throw Error(res.err.message)
      // console.table(res)

      setDqrHwCon(true)
      setDqrHwInfo(res)
    } catch (e) {
      let errMsg = e.message
      if (e.message === "Network Error") errMsg = "Bridge App NOT Connected"
      alert(errMsg)
      setDqrHwCon(false)
      setDqrHwInfo({})
      setVisibleProvision(false)
    }
  }

  const onClickItem = async (obj) => {
    setSelDqr(obj)
    setVisible(true)
  }

  return (
    <Page>
      <CardContainer
        title="DQR Settings"
        onClickBack={() => props.history.push("/")}
      >

        <Button variant="outline-primary" title="Connect DQR" onClick={checkDqrConnection} size="sm" />
        <hr />

        <Header
          setIsEdit={setIsEdit}
          setVisibleProvision={setVisibleProvision}
          dqrHwCon={dqrHwCon}
          dqrHwInfo={dqrHwInfo}
        />

        <CustomTable
          tableHeader={tableHeader}
          rowItems={dqrList}
          onClickItem={onClickItem}
        />
      </CardContainer>

      <DqrResyncModal
        visible={visible}
        setVisible={setVisible}
        dqr={selDqr}
      />

      {visibleProvision &&
        <DqrProvisionModal
          visible={visibleProvision}
          setVisible={setVisibleProvision}
          checkConnection={checkDqrConnection}
          isEdit={isEdit}
          dqr={dqrHwInfo}
          shopInfo={shopInfo}
          itemOptions3={itemOptions3}
          updateDqrList={listDqrs}
        />
      }
    </Page>
  );
}

function Header(props) {
  const { setIsEdit, setVisibleProvision, dqrHwCon, dqrHwInfo } = props
  const { gStyle, colors } = useStyles();

  const styles = {
    subTitleBar: {
      display: "flex",
      alignItems: "center"
    },
    subTitle: { ...gStyle.subtitle },
    iconPlus: { ...gStyle.subtitle, color: colors.primary, marginLeft: 10 },
  }

  return (
    <div style={{ ...styles.subTitleBar, justifyContent: "space-between", marginBottom: 5 }}>
      <div style={styles.subTitleBar}>
        <p style={styles.subTitle}>Provisioned DQR List</p>
        {dqrHwCon &&
          <Plus
            style={styles.iconPlus}
            onClick={() => {
              setIsEdit(false)
              setVisibleProvision(true)
            }}
          />
        }
      </div>

      {dqrHwCon &&
        <div style={styles.subTitleBar}>
          <p style={styles.subTitle} >
            <span
              style={{ color: colors.danger, cursor: "pointer", fontSize: "1rem" }}
              onClick={() => {
                setIsEdit(true)
                setVisibleProvision(true)
              }}
            >{dqrHwInfo.uid}</span>
            &nbsp;&nbsp;
            {/* <ConSign /> */}
            <ConnectSign />
          </p>
        </div>
      }
    </div>
  )
}

function ConSign() {
  const { colors } = useStyles();
  const [passTime, setPassTime] = useState(false)

  useEffect(() => {
    const iv = setInterval(() => {
      setPassTime(pre => !pre)
    }, 500)

    return () => clearInterval(iv)
  }, [])

  return <CircleFilled style={{ color: passTime ? colors.danger : colors.warning }} />
}